import { render } from "./AdditionalExpenseForm.vue?vue&type=template&id=afd4c6b6&scoped=true"
import script from "./AdditionalExpenseForm.vue?vue&type=script&lang=js"
export * from "./AdditionalExpenseForm.vue?vue&type=script&lang=js"

import "./AdditionalExpenseForm.vue?vue&type=style&index=0&id=afd4c6b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd4c6b6"]])

export default __exports__